// src/App.jsx
// Point d'entrée SOLSTICE v68
// Le bandeau utilisateur (📥 👥 🚪) est géré dans AppPrincipale.jsx

import React from 'react'
import * as Sentry from '@sentry/react'
import { AuthProvider, useAuth } from './contexts/AuthContext'
import LoginPage from './pages/LoginPage'
import AppPrincipale from './AppPrincipale'

function AppRouter() {
  const { user, loading } = useAuth()

  if (loading) return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0F172A 0%, #1E293B 100%)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: "'Bricolage Grotesque', sans-serif",
    }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{
          fontSize: '2rem', fontWeight: 800,
          background: 'linear-gradient(135deg, #FF6B35, #00D4AA)',
          WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
          marginBottom: '1rem',
        }}>
          ☀️ SOLSTICE
        </div>
        <div style={{ color: '#64748B', fontSize: '0.9rem' }}>Chargement…</div>
      </div>
    </div>
  )

  if (!user) return <LoginPage />

  return <AppPrincipale />
}

const FallbackErreur = ({ error, resetError }) => (
  <div style={{
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #0F172A 0%, #1E293B 100%)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontFamily: "'Bricolage Grotesque', sans-serif",
  }}>
    <div style={{ textAlign: 'center', maxWidth: 480, padding: '2rem' }}>
      <div style={{
        fontSize: '2rem', fontWeight: 800,
        background: 'linear-gradient(135deg, #FF6B35, #00D4AA)',
        WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
        marginBottom: '1rem',
      }}>
        ☀️ SOLSTICE
      </div>
      <p style={{ color: '#F87171', fontWeight: 600, marginBottom: '0.5rem' }}>
        Une erreur inattendue s'est produite.
      </p>
      <p style={{ color: '#64748B', fontSize: '0.8rem', marginBottom: '1.5rem' }}>
        {error?.message}
      </p>
      <button
        onClick={resetError}
        style={{
          background: 'linear-gradient(135deg, #FF6B35, #00D4AA)',
          border: 'none', borderRadius: 8, padding: '0.6rem 1.5rem',
          color: '#fff', fontWeight: 700, cursor: 'pointer',
        }}
      >
        Réessayer
      </button>
    </div>
  </div>
)

export default function App() {
  return (
    <Sentry.ErrorBoundary fallback={FallbackErreur} showDialog={false}>
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
    </Sentry.ErrorBoundary>
  )
}
